import moment from 'moment/moment';

export const enochFilterDateFormat = 'YYYY-MM-DD';

export const dateRangeConfigs = [
  {
    id: -1,
    title: 'Lifetime',
    fromDate: '1970-01-01',
    toDate: '9999-12-31',
  },
  {
    id: 0,
    title: 'Custom',
  },
  {
    id: 1,
    title: 'Today',
    fromDate: moment().format(enochFilterDateFormat),
    toDate: moment().format(enochFilterDateFormat),
  },
  {
    id: 2,
    title: 'Yesterday',
    fromDate: moment()
      .subtract(1, 'day')
      .format(enochFilterDateFormat),
    toDate: moment().format(enochFilterDateFormat),
  },
  {
    id: 3,
    title: 'This week',
    fromDate: moment()
      .startOf('isoWeek')
      .format(enochFilterDateFormat),
    toDate: moment().format(enochFilterDateFormat),
  },
  {
    id: 4,
    title: 'Last week',
    fromDate: moment()
      .subtract(1, 'isoWeek')
      .startOf('isoWeek')
      .format(enochFilterDateFormat),
    toDate: moment()
      .subtract(1, 'isoWeek')
      .endOf('isoWeek')
      .format(enochFilterDateFormat),
  },
  {
    id: 5,
    title: 'Last 7 days',
    fromDate: moment()
      .subtract(7, 'days')
      .format(enochFilterDateFormat),
    toDate: moment().format(enochFilterDateFormat),
  },
  {
    id: 6,
    title: 'Last 28 days',
    fromDate: moment()
      .subtract(28, 'days')
      .format(enochFilterDateFormat),
    toDate: moment().format(enochFilterDateFormat),
  },
  {
    id: 7,
    title: 'Last 30 days',
    fromDate: moment()
      .subtract(30, 'days')
      .format(enochFilterDateFormat),
    toDate: moment().format(enochFilterDateFormat),
  },
  {
    id: 8,
    title: 'Last 90 days',
    fromDate: moment()
      .subtract(90, 'days')
      .format(enochFilterDateFormat),
    toDate: moment().format(enochFilterDateFormat),
  },
];

export const mapIpToMachineName = {
  '3.6.235.254': 'Virtual Machine Abdullah',
  '43.204.33.229': 'Virtual Machine Akash Raj',
  '110.226.176.135': 'Virtual Machine Antika',
  '65.0.228.80': 'Virtual Machine Anubrata',
  '3.6.246.111': 'Virtual Machine Arindam',
  '13.127.154.56': 'Virtual Machine Atika',
  '43.205.61.202': 'Virtual Machine JK',
  '43.204.172.217': 'Virtual Machine Kshitij',
  '15.207.154.164': 'Virtual Machine Kumaresh',
  '13.235.239.27': 'Virtual Machine Nizam',
  '3.111.1.218': 'Virtual Machine Pooja',
  '43.204.184.6': 'Virtual Machine Prachi',
  '13.127.28.81': 'Virtual Machine Pratyush',
  '43.204.133.181': 'Virtual Machine Priya',
  '65.1.246.195': 'Virtual Machine Ranjith',
  '3.6.33.49': 'Virtual Machine Rohit',
  '43.205.14.9': 'Virtual Machine Rinkey',
  '43.205.56.18': 'Virtual Machine Sai',
  '13.234.172.169': 'Virtual Machine Sarthak',
  '43.204.167.138': 'Virtual Machine Subhajit Sen',
  '122.161.51.212': 'Virtual Machine Vijay',
  '13.126.172.242': 'Virtual Machine Vivek',
  '3.6.134.83': 'Virtual Machine Zaid',
  '43.204.88.50': '(old) Virtual Machine Ankita',
  '13.126.57.237': '(old) Virtual Machine Vijay',
  '3.0.63.216': '(old) Virtual Machine Vivek',
};
